export default "__VITE_ASSET__4574dba4__"